import {IResponse} from '../../../common/model/Core.model'
import {environment} from '../../../util/Environment'
import {apiSlice} from '../../store/Api'
import { IATicket, ITicketCreateRequestDto, ITicketMediaDeleteRequestDto, ITicketSearchRequestDto, ITicketUpdateRequestDto } from './Ticket.model'

export const ticketApi = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      ticketMediaDeleteById: builder.mutation<void, ITicketMediaDeleteRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.ticket}/media/${body.id}?ticketId=${body.ticketId}`,
            method: 'DELETE',
          }
        },
      }),
      ticketSearch: builder.mutation<IResponse, ITicketSearchRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.ticket}/search`,
            method: 'POST',
            body,
          }
        },
      }),
      ticketLoadMore: builder.mutation<IResponse, ITicketSearchRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.ticket}/search`,
            method: 'POST',
            body,
          }
        },
      }),
      ticketGetById: builder.mutation<IATicket, {id: string; fields?: string}>({
        query(parameters) {
          const queryParams = parameters.fields ? `?fields=${parameters.fields}` : ''
          return {
            url: `${environment.apiUrl.ticket}/${parameters.id}` + queryParams,
            method: 'GET',
          }
        },
      }),
      ticketCreate: builder.mutation<IATicket, ITicketCreateRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.ticket}`,
            method: 'POST',
            body,
          }
        },
      }),
      ticketUpdateById: builder.mutation<IATicket, ITicketUpdateRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.ticket}/${body.id}`,
            method: 'PATCH',
            body,
          }
        },
      }),
      ticketDeleteById: builder.mutation<void, string>({
        query(id) {
          return {
            url: `${environment.apiUrl.ticket}/${id}`,
            method: 'DELETE',
          }
        },
      }),
    }
  },
})

export const {
  useTicketMediaDeleteByIdMutation,
  useTicketSearchMutation,
  useTicketLoadMoreMutation,
  useTicketCreateMutation,
  useTicketUpdateByIdMutation,
  useTicketGetByIdMutation,
  useTicketDeleteByIdMutation,
} = ticketApi
